import HipAPI from '@/lib/HipApi';

const hipApi = HipAPI.getInstance();

const state = () => ({
    usersTickets: [],
    loading: false,
});

const mutations = {
    setTickets(state: any, payload: any) {
        state.usersTickets = payload.tickets;
    },
    setLoading(state: any, payload: any) {
        state.loading = payload;
    },
};

const actions = {
    getTickets({ commit }: any, payload: any) {
        if (payload.dateRange.length === 2 && payload.userId) {
            commit('setTickets', { tickets: [] });
            if (payload.userId > 0) {
                commit('setLoading', true);
                hipApi.getUserTickets(payload.userId, payload.dateRange[0] as string, payload.dateRange[1] as string)
                    .then((res: any) => {
                        commit('setTickets', { tickets: res });
                    })
                    .catch((err) => {
                        commit('notificationDialog/showMessage', { type: 'error', title: 'Error', msg: err?.error?.message || err?.message || err }, { root: true });
                    })
                    .finally(() => {
                        commit('setLoading', false);
                    });
            }
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
